var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        mousedown: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "add-dialog" },
        [
          _c("div", { staticClass: "add-header" }, [
            _vm.mode !== "freeLimit"
              ? _c("span", { staticClass: "add-header-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.mode === "premiumLimit"
                          ? _vm.$t(
                              "homePage.novelList.grouping.premiumLimitTitle"
                            )
                          : _vm.$t("homePage.novelList.grouping.addGroup")
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c(
              "button",
              { staticClass: "add-close-button", on: { click: _vm.onCancel } },
              [_c("IconClose", { staticClass: "add-close-icon" })],
              1
            ),
          ]),
          _vm.mode === "freeLimit"
            ? [
                _c("div", { staticClass: "add-limit-body" }, [
                  _c("img", {
                    staticClass: "add-limit-mascot",
                    attrs: { src: _vm.mascotImageSrc, alt: "" },
                  }),
                  _c("h3", { staticClass: "add-limit-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("homePage.novelList.grouping.freeLimitTitle")
                      )
                    ),
                  ]),
                  _c("p", { staticClass: "add-limit-description" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("homePage.novelList.grouping.freeLimitMessage")
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "add-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "add-premium-button",
                      on: { click: _vm.onClickPremium },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("homePage.novelList.grouping.becomePremium")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "add-cancel-button",
                      on: { click: _vm.onCancel },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
                  ),
                ]),
              ]
            : _vm.mode === "premiumLimit"
            ? [
                _c("div", { staticClass: "add-limit-message" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "homePage.novelList.grouping.premiumLimitMessage"
                        )
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "add-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "add-cancel-button",
                      on: { click: _vm.onCancel },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
                  ),
                ]),
              ]
            : [
                _c("div", { staticClass: "add-body" }, [
                  _c("div", { staticClass: "add-label-row" }, [
                    _c("span", { staticClass: "add-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("homePage.novelList.grouping.groupName"))
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "add-char-count",
                        class: { over: _vm.isOverLimit },
                      },
                      [_vm._v(_vm._s(_vm.charCount) + "/50")]
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.groupName,
                        expression: "groupName",
                      },
                    ],
                    staticClass: "add-input",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t(
                        "homePage.novelList.grouping.groupNamePlaceholder"
                      ),
                      maxlength: _vm.GROUP_NAME_MAX_LENGTH,
                    },
                    domProps: { value: _vm.groupName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.groupName = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "add-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "add-submit-button",
                      attrs: { disabled: !_vm.canSubmit },
                      on: { click: _vm.onSubmit },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("homePage.novelList.grouping.add")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "add-cancel-button",
                      on: { click: _vm.onCancel },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                  ),
                ]),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }